module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/InfluencerExample/0_1-e718cde05582cd51e11fc9ec483e14db.png";